import actionWrapper from '../_actionWrapper';
import RequestResourceCompletedById from '../resource/RequestResourceCompletedById';

const requestResourceCompletedById = (() => actionWrapper(RequestResourceCompletedById))();

/**
 * @visibleName requestResourceCompletedById
 * @component
 */
export default requestResourceCompletedById;
